<template>
  <div class="footer-box">
    <div class="footer-content">
      <div class="info-box">
        <div class="info-left">
          <div class="company-name">{{ baseConf.name || footerInfo.companyName }}</div>
          <div class="page-row">
            <div class="page-item" @click="gotoPage('enterprise')">
              <div class="triangle"></div>
              <div class="page-text">企业概况</div>
            </div>
            <div class="page-item" @click="gotoPage('bizScope')">
              <div class="triangle"></div>
              <div class="page-text">技术服务</div>
            </div>
            <div class="page-item" @click="gotoPage('contact')">
              <div class="triangle"></div>
              <div class="page-text">联系我们</div>
            </div>
          </div>
          <div class="page-row">
            <div class="page-item" @click="gotoPage('honor')">
              <div class="triangle"></div>
              <div class="page-text">资质荣誉</div>
            </div>
            <div class="page-item" @click="gotoPage('case')">
              <div class="triangle"></div>
              <div class="page-text">服务案例</div>
            </div>
            <div class="page-item" @click="gotoPage('news')">
              <div class="triangle"></div>
              <div class="page-text">新闻中心</div>
            </div>
          </div>
        </div>
        <div class="info-middle">
          <div class="middle-row">
            <div class="middle-row-label">电话：</div>
            <div class="middle-row-value phone-list">
              <div v-for="(item, index) in footerInfo.telList" :key="index" class="phone">
                <span class="phone-num">{{ item.num }}</span>
                <span class="phone-tag"> {{ item.tag }}</span>
              </div>
            </div>
          </div>
          <div class="middle-row">
            <div class="middle-row-label">地址：</div>
            <div class="middle-row-value">{{ footerInfo.address }}</div>
          </div>
        </div>
        <div class="info-right">
          <div class="qr-item">
            <div class="img-box">
              <img :src="$utils.getFileHttpUrl(baseConf.mpQr)" />
            </div>
            <div class="img-text">扫码关注公众号</div>
          </div>
          <div class="qr-item">
            <div class="img-box">
              <img :src="$utils.getFileHttpUrl(baseConf.miniQr)" />
            </div>
            <div class="img-text">微信小程序下单</div>
          </div>
        </div>
      </div>

      <div class="copyright">Copyright © 2023 志诚信 All Rights Reserved   备案号： 蜀ICP备19026401号</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      baseConf: {},
      footerInfo: {
        companyName: '四川志诚信市政工程有限公司',
        telList: [
          { num: '400-028-1983', tag: '全国统一客服热线' },
          { num: '0831-2022888', tag: '（宜宾）子公司电话' },
          { num: '028-87308888', tag: '（成都）总公司电话' },
          { num: '028-87308777', tag: '（成都）总公司电话' }
        ],
        address: '四川省成都市青羊区双锦路51号1栋1层7号'
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.name = to.name
      }
    }
  },
  created() {
    this.getBaseConf()
  },
  methods: {
    getBaseConf() {
      this.$http.getAction('/portal/api/v1/index/base/conf').then((res) => {
        if (res.success) {
          this.baseConf = res.data
          if (res.data.tel) {
            this.baseConf.tel = res.data.tel.split(',')
          }
        }
      })
    },
    gotoPage(name) {
      if(this.name == name) return
      this.$router.replace({ name: name })
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-box {
  background-color: #222222;
  padding: 43px 0 12px 0;
  .footer-content {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;

    .info-box {
      display: flex;
      justify-content: space-between;

      .info-left {
        .company-name {
          height: 20px;
          font-weight: bold;
          font-size: 18px;
          color: #dbdbdb;
          line-height: 20px;
          margin-bottom: 10px;
        }
        .page-row {
          display: flex;
          align-items: center;
          .page-item {
            display: flex;
            align-items: center;
            padding: 20px 0 13px 0;
            width: 150px;
            border-bottom: 1px solid #606060;
            margin-right: 32px;
            cursor: pointer;
            &:nth-of-type(3) {
              margin-right: 0px;
            }
            .triangle {
              width: 0;
              height: 0;
              border-top: 5px solid transparent;
              border-bottom: 5px solid transparent;
              border-left: 10px solid #d9d9d9;
            }
            .page-text {
              padding-left: 7px;
              font-weight: bold;
              font-size: 14px;
              color: #dbdbdb;
            }
          }
        }
      }
      .info-middle {
        height: 135px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .middle-row {
          display: flex;
          font-weight: bold;
          font-size: 14px;
          color: #dbdbdb;
          line-height: 20px;
          .middle-row-value {
            .phone-list {
              display: flex;
              flex-wrap: wrap;
              width: 360px;
              .phone {
                width: 50%;
                margin-bottom: 10px;
                height: 21px;
                line-height: 21px;
                font-weight: bold;
                font-size: 14px;
                color: #dbdbdb;
                text-align: left;
                .phone-tag {
                  font-weight: 500;
                  font-size: 12px;
                  color: #bababa;
                }
              }
            }
          }
        }
      }
      .info-right {
        display: flex;
        .qr-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 30px;
          &:first-child {
            margin-left: 0;
          }
          .img-box {
            width: 100px;
            height: 100px;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid rgba(107, 119, 154, 0.15);
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .img-text {
            margin-top: 10px;
            height: 18px;
            font-weight: 500;
            font-size: 12px;
            color: #bababa;
            line-height: 18px;
            text-align: center;
          }
        }
      }
    }

    .copyright {
      padding-top: 20px;
      font-weight: 500;
      font-size: 12px;
      color: #bababa;
      line-height: 15px;
      text-align: center;
    }
  }
}
</style>
